import { useId, type ReactNode } from "react";

import { CloseIcon } from "./ActionIcons";
import { IconButton } from "./IconButton";

export function SidePeek({
  id,
  ariaLabel,
  eyebrow,
  title,
  closeLabel,
  className,
  headerless = false,
  children,
  onClose,
}: {
  id?: string;
  ariaLabel: string;
  eyebrow?: ReactNode;
  title: string;
  closeLabel: string;
  className?: string;
  headerless?: boolean;
  children: ReactNode;
  onClose: () => void;
}) {
  const titleId = useId();
  return (
    <aside
      id={id}
      className={[
        "ui-side-peek",
        headerless ? "ui-side-peek--headerless" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={ariaLabel}
      aria-labelledby={headerless ? undefined : titleId}
    >
      {headerless ? (
        <IconButton
          containerClassName="ui-side-peek__floating-close"
          tone="quiet"
          size="sm"
          label={closeLabel}
          tooltip={closeLabel}
          icon={<CloseIcon />}
          onClick={onClose}
        />
      ) : (
        <header className="ui-side-peek__header">
          <div>
            {eyebrow && (
              <span className="ui-side-peek__eyebrow">{eyebrow}</span>
            )}
            <h2 id={titleId}>{title}</h2>
          </div>
          <IconButton
            tone="quiet"
            size="sm"
            label={closeLabel}
            tooltip={closeLabel}
            icon={<CloseIcon />}
            onClick={onClose}
          />
        </header>
      )}
      <div className="ui-side-peek__body">{children}</div>
    </aside>
  );
}
